var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isValidPdfUrl
    ? _c("div", { staticClass: "etc-eek-datasheet" }, [
        _c(
          "a",
          {
            staticClass: "openProduktdatenblattWrapper btn",
            attrs: { href: "/#", id: "loadPdf", rel: "nofollow" },
            on: { click: _vm.loadPdfViewer }
          },
          [
            _vm._v(
              _vm._s(
                _vm.$translate(
                  "ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt"
                )
              ) + "\n  "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wrapper wrap-left h-100 empty",
            attrs: { id: "productDatasheetModalWrapper" }
          },
          [
            _c("div", { staticClass: "modalBody bg-white w-100 h-100" }, [
              _c("div", { staticClass: "modalHeader" }, [
                _c("div", { staticClass: "title-section" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$translate(
                          "ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt"
                        )
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "close-modal-button",
                  attrs: { type: "button" },
                  on: { click: _vm.closeModal }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modalContent",
                  staticStyle: { padding: "0 0.001rem 0 0" },
                  attrs: { id: "productDatasheetContent" }
                },
                [
                  _vm.showPdf
                    ? [
                        _c("lazy-pdf-viewer", {
                          attrs: { "pdf-url": _vm.pdfUrl }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "overlay", on: { click: _vm.closeModal } })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }